enum OrderFinishedListingSortKey {
  CARGO_COMPANY_INTERNAL_ID_ASC = "CARGO_COMPANY_INTERNAL_ID_ASC",
  CARGO_COMPANY_INTERNAL_ID_DESC = "CARGO_COMPANY_INTERNAL_ID_DESC",
  START_TIME_ASC = "START_TIME_ASC",
  START_TIME_DESC = "START_TIME_DESC",
}

export default OrderFinishedListingSortKey;
